<template>
    <div class="pta-admin">
        <div class="page-titles border-bottom">
            <h3>AI Email Data</h3>
        </div>
        <div class="container-fluid p-0">

            <script
                type="module"
                src="https://gradio.s3-us-west-2.amazonaws.com/4.31.2/gradio.js"
            ></script>
            <gradio-app src="https://fabianbg-emailui.hf.space"></gradio-app>

        </div>
    </div>
</template>
<script>
    export default {
        components : {  },
        data() {
            return {
            };
        },
        mounted(){
         // this.uuid = 'bb346ff3-de6e-45ae-a33f-9f0fbf661705';
        //  this.getValues();
        },
        methods: {

        },
        filters: {

        }
    }
</script>
<style>
.pta-iframe-container {
  width: 100%;
  overflow: hidden; /* Verhindert Scrollen, falls das iframe zu groß wird */
  position: relative;
}

#pta-iframe-container iframe {
  width: 100%;
  border: none;
}
</style>
